<template>
  <div class="answerPage" :class="{'answerPage_navigation': isFengChaoShow}">
    <zdy-nav :leftTitle="title" @back="back"></zdy-nav>
    <div class="content">
      <div class='Qtext'>
        <div class='text'>{{ questionName }}</div>
      </div>
      <div class='Atext'>
        <div class='text' v-html="answer"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: '详情',
      answer: '',
      questionName: ''
    }
  },
  computed: {
    isFengChaoShow() {
      return this.$store.state.isFengChaoShow
    },
  },
  created() {
    const { params } = this.$route;
    this.questionName = params.questionName || params.name;
    this.answer = params.answer || params.value;
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
  }
}
</script>

<style lang="scss">
.answerPage_navigation {
  .content {
    margin: 8px 12px 34px 12px !important;
  }
}
.answerPage {
  height: 100vh;
  background-color: #F0F2F3;
  overflow-y: scroll;
  .content {
    width: calc(100vw - 24px);
    background-color: #FFFFFF;
    font-size: 14px;
    padding: 16px;
    border-radius: 6px;
    margin: 52px 12px 34px 12px;
    .Qtext{
      padding-bottom: 15px;
      border-bottom: 1px solid #F1F2F3;
      .text{
        font-size: 16px;
        font-weight: bold;
        color: #1A1A1A;
        line-height: 24px;
        word-break: break-all;
        word-wrap: break-word;
      }
    }
    .Atext{
      padding-top: 7px;
      .text{
        font-size: 15px;
        color: #6D7073;
        line-height: 26px;
        word-break: break-all;
        word-wrap: break-word;
        white-space: pre-wrap;
      }
    }
  }
}
</style>